var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgModify(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12.666,
    height: 14,
    viewBox: "0 0 12.666 14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#6f6f6f;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M9.5,4A1.5,1.5,0,0,0,8,5.5V15.833a1.5,1.5,0,0,0,1.5,1.5h3.181a1.167,1.167,0,0,1,.062-.245h0c.018-.075.04-.153.063-.234l.15-.522H9.5a.5.5,0,0,1-.5-.5V5.5A.5.5,0,0,1,9.5,5h3.833V7.833a1.5,1.5,0,0,0,1.5,1.5h2.833v1.277a2.208,2.208,0,0,1,1-.547V8.833a.5.5,0,0,0-.146-.353L14.187,4.146A.5.5,0,0,0,13.833,4Zm4.833,1.707,2.626,2.626H14.833a.5.5,0,0,1-.5-.5Zm4.833,4.96a1.568,1.568,0,0,0-.277.025,1.545,1.545,0,0,0-.814.445l-3.933,3.933a1,1,0,0,0-.253.428l-.523,1.827a.506.506,0,0,0-.033.2A.494.494,0,0,0,13.81,18a.508.508,0,0,0,.2-.033l1.827-.523a1,1,0,0,0,.428-.253L20.2,13.258a1.545,1.545,0,0,0,.445-.814,1.6,1.6,0,0,0,.025-.277,1.5,1.5,0,0,0-1.5-1.5Z",
    transform: "translate(-8 -4)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgModify);
export default __webpack_public_path__ + "static/media/modify.c0749f7ee2e044275866a573f209f414.svg";
export { ForwardRef as ReactComponent };